<template>
  <v-container fluid>
    <v-row v-if="dynamicForm">
      <v-col class="text-h3 gray--text">
        {{ dynamicForm.title }}
      </v-col>
    </v-row>

    <DynamicFormCore
      v-model="dynamicForm"
      :dynamicFormType="dynamicFormType"
      :answerableId="answerableId"
      :answerableType="answerableType"
      :disabled="disabled"
    >
      <template v-slot:useButton="{ shard }">
        <slot name="useButton" v-bind:shard="shard"></slot>
      </template>
    </DynamicFormCore>
  </v-container>
</template>

<script>
  import DynamicFormCore from "@/components/dynamic_form/core.vue";

  export default {
    name: "DynamicForm",
    components: {
      DynamicFormCore,
    },
    props: {
      dynamicFormType: String,
      answerableId: String,
      answerableType: String,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        dynamicForm: null,
      };
    },
  };
</script>

<style lang="scss" scoped></style>
